module.exports = __webpack_public_path__ + "static/media/6.f715e425.jpeg";